import { Target } from "lucide-react";

function CircularProgress({ percent, size = 88, strokeWidth = 8 }) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (Math.min(percent, 100) / 100) * circumference;

  return (
    <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
      {/* Track */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
        stroke="#e2e8f0"
        fill="none"
      />
      {/* Progress */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={strokeWidth}
        stroke="#1e3a5f"
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={offset}
        strokeLinecap="round"
        style={{ transition: "stroke-dashoffset 0.7s ease-out" }}
      />
    </svg>
  );
}

export default function OverallProgressCard({ percent, totalSubs, selesai }) {
  const pct = Number.isFinite(percent) ? percent : 0;
  return (
    <div
      data-testid="overall-progress-card"
      className="flex flex-col rounded-2xl border border-blue-100/60 p-5 shadow-sm print:shadow-none relative overflow-hidden"
      style={{ background: "linear-gradient(135deg, #eff6ff 0%, #ffffff 55%)" }}
    >
      {/* Colored header band */}
      <div
        className="-mx-5 -mt-5 px-5 py-4 mb-4 rounded-t-2xl"
        style={{ background: "linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)" }}
      >
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/20">
              <Target className="h-5 w-5 text-white" strokeWidth={2} />
            </div>
            <div>
              <h3 className="font-display text-base font-bold text-white leading-tight">
                Capaian Keseluruhan
              </h3>
              <p className="text-[11px] text-blue-200 mt-0.5">
                Progres keseluruhan sub-kegiatan
              </p>
            </div>
          </div>
          <span className="text-[11px] font-semibold text-white bg-white/20 px-2.5 py-1 rounded-full">
            Agregat
          </span>
        </div>
      </div>

      <div className="flex items-center gap-4">
        {/* Circular ring */}
        <div className="relative flex-shrink-0">
          <CircularProgress percent={pct} />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-display text-[14px] font-bold text-slate-900">{pct}%</span>
          </div>
        </div>

        {/* Text info */}
        <div className="flex-1 min-w-0">
          <div className="font-display text-3xl font-bold text-[#1e3a5f]">{pct}%</div>
          <div className="mt-0.5 text-[11px] text-slate-400">
            {selesai} / {totalSubs} sub selesai
          </div>
          {/* Mini progress bar */}
          <div className="mt-2.5 h-1.5 w-full overflow-hidden rounded-full bg-slate-100">
            <div
              data-testid="overall-progress-bar"
              className="h-full rounded-full bg-gradient-to-r from-[#1e3a5f] to-blue-500 transition-all duration-700"
              style={{ width: `${pct}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
